import React, { Fragment } from 'react'

const Accessability = () => {
    return (
        <Fragment>
            <h2>Accessibility & SEO Audit</h2>
            <p>
                The importance of Accessibility and SEO in our day to day
                interactions of effects on every aspect of our clients products.
                These two areas combined have effects on how your application
                ranks and is reachable to audiences searching for your product
                and service on google and other search engines and the
                interaction with devices like screen readers and other tools for
                users that need accommodations. For most of the systems we use
                to complete our comprehensive Application Audit, these two areas
                alone account for 50% of the audit, and failing in these two
                areas will have a drastic effect on your traffic.
            </p>
            <h3>Key Metrics</h3>
            <ul>
                <div className="leftList">
                    <li>Quantity of A and AA success criteria violations</li>
                    <li>WCAG 2.0 Conformance Level</li>
                    <li>Keyword Targeting</li>
                    <li>Search Visibility</li>
                    <li>Organic Traffic</li>
                    <li>Site authority</li>
                    <li>Site security</li>
                </div>
                <div className="rightList">
                    <li>Time taken to conduct a task</li>
                    <li>Media without alt attributes</li>
                    <li>Accessibility Failure points</li>
                    <li>Accessibility Barriers</li>
                    <li>Site Responsiveness</li>
                    <li>Pages per session</li>
                    <li>Bounce Rate</li>
                </div>
            </ul>
        </Fragment>
    )
}

export default Accessability
